import { Col, Container, Row, Stack } from "react-bootstrap";
import clsx from "classnames";
import classes from "./styles.module.scss";
import { Body, CTA, Title } from "@/ui";

export function RichText({ bgColor, textColor, titleColor, className, containerClassName, title, content, ctas }) {
  const hasCtas = ctas && ctas.map((i) => i.label).join("").length > 0;

  return (
    <div className={clsx(className, bgColor, textColor, classes.text)}>
      <Container className={containerClassName}>
        <Row>
          <Col xs={12}>
            <Title className={titleColor} title={title} />
            <Body body={content} />
            {hasCtas && (
              <Stack className="flex-md-row mt-4" gap={2}>
                {ctas.map((cta, k) => (
                  <CTA key={k} label={cta.label} href={cta.href} variant={cta.variant} />
                ))}
              </Stack>
            )}
          </Col>
        </Row>
      </Container>
    </div>
  );
}

export default RichText;
